import { cn } from '@/lib/utils';

// MoneyCell and CountCell moved to `@/components/shared/NumberCells` once
// Settings > Billing drew a second bill with them.

/**
 * Finds a no-price warning: `data-no-price` (its value is the row's key) sits
 * on every warning an owner sees on the bill and in the clients table. The total
 * panel's "Not final" note finds the first one, scrolls its row into view and
 * focuses it (C3). `tabIndex={-1}`: focusable by script only, never a tab
 * stop, so a screen reader reads the warning itself on arrival.
 */
export const NO_PRICE_SELECTOR = '[data-no-price]';

/** Where focus lands is visible: a ring on keyboard arrival, the row tint on any. */
export const NO_PRICE_FOCUS =
  'rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

/**
 * A small text action beside a warning (Set price on a bill row, Show on the
 * total panel): purple, underlined on hover, with a taller invisible hit area
 * (`before:`) so the 12px text is easier to tap, and a focus ring.
 */
export const INLINE_ACTION_CLASS =
  "relative rounded-sm text-xs font-medium text-primary-strong underline-offset-2 before:absolute before:inset-x-0 before:-bottom-1 before:-top-1 before:content-[''] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

interface SwatchProps {
  colour: string | undefined;
  /** The chart tooltip's smaller key. */
  small?: boolean;
}

/** A colour key. Always beside the name it stands for, so screen readers skip it. */
export function Swatch({ colour, small = false }: SwatchProps) {
  return (
    <span
      className={cn(small ? 'h-2 w-2' : 'h-2.5 w-2.5', 'shrink-0 rounded-[3px]')}
      style={{ backgroundColor: colour }}
      aria-hidden="true"
    />
  );
}
